<template>
  <div>
    <div style="margin-bottom: 24px;" v-if="!hideBtn">
      <el-button @click="allCheck" v-if="!isAllCheck">全选</el-button>
      <el-button @click="noAllCheck" v-if="isAllCheck">取消全选</el-button>
      <el-button type="danger" @click="batchDelImg" v-loading="delLoading">批量删除</el-button>
    </div>
    <div v-loading="listLoading">
      <el-space wrap v-if="imgArray.length > 0" :size="16">
        <div v-for="(item, index) in imgArray" :key="item.id" class="space-item">
          <div class="item-box">
            <div class="list-item">
              <div @click="isCheckChange(index)" v-if="!hideBtn">
                <el-image class="item-img" fit="cover" :src="item.smallImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
              </div>
              <div v-else>
                <el-image class="item-img" fit="cover" :src="item.smallImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
              </div>
              <div @click="isCheckChange(index)" class="check-icon" v-if="item.check"><i class="fa fa-check fa-lg" aria-hidden="true"></i></div>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="查看大图"
                  placement="top"
              >
                <div class="scale-icon" @click.prevent="showImg(index)"><i class="fa fa-arrows-alt" aria-hidden="true"></i></div>
              </el-tooltip>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="设为封面"
                  placement="top"
              >
                <div v-if="from == 2 && !hideBtn" class="set-icon" @click.prevent="setCover(item.id)"><i class="fa fa-image" aria-hidden="true"></i></div>
              </el-tooltip>
              <div v-if="item.isCover == 1" class="cover-tag">封面</div>
            </div>
          </div>
        </div>
      </el-space>
      <el-empty v-else description="没有更多数据"></el-empty>
    </div>
  </div>
</template>

<script>
import { imgPostFormData, postFormData } from "@/api/api"
import {
  uploadUserImg,
  updateUserImgDel,
  delCommodityImg,
  uploadCommodityImgCover,
  updateStockTakeCommodityImgDel,
  uploadVisitImgDel,
  delStandardImg,
  delSysRole
} from "@/api/url";
import ImgViewer from '@/assets/js/imageViewer'

export default {
name: "UserImgUpload",
  props: {
    value: Object
  },
  data() {
    return {
      from: this.value.from, //1客户管理； 2商品管理；3盘点记录; 4回访截图; 5:入库记录; 6:卫生标准
      imgArray: this.value.imgArray,
      id: this.value.id,

      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      delLoading: false,

      //是否全选
      isAllCheck: false,

      hideBtn: this.value.hideBtn,

    }
  },
  methods: {

    //全选
    allCheck(){
      this.isAllCheck = true;
      for(let i=0;i<this.imgArray.length;i++){
        this.imgArray[i]['check'] = true;
      }
    },

    //取消全选
    noAllCheck() {
      this.isAllCheck = false;
      for(let i=0;i<this.imgArray.length;i++){
        this.imgArray[i]['check'] = false;
      }
    },

    //选中状态
    isCheckChange(idx) {
      this.imgArray[idx]['check'] = !this.imgArray[idx]['check'];
    },


    showImg(idx) {
      let imgList = []
      for(let i=0; i<this.imgArray.length; i++) {
        imgList.push(this.imgArray[i].img)
      }
      ImgViewer.open({
        imgList: imgList,
        imgIndex: idx
      })
    },


    cancel() {
      this.$emit("close");
    },

    //更改或添加
    fileUpdate() {
      this.$refs.file.setAttribute('type', 'file')
      this.$refs.file.click();
    },

    //选取图片
    fileChanged(e) {
      if(e.target.files[0]) {
        for(let item of e.target.files) {
          let windowURL = window.URL || window.webkitURL;
          let src = windowURL.createObjectURL(item);
          let obj = {'img': src, 'smallImg': src, 'files': item};
          this.imgArray.push(obj);
        }
        this.$refs.file.setAttribute('type', 'text')
      }
    },

    // 删除图片
    delImg(idx) {
      if(this.imgArray[idx].id >= 0) {
        this.delImgIdArray.push(this.imgArray[idx].id);
      }
      this.imgArray.splice(idx,1);
    },


    batchDelImg() {
      if(this.imgArray.every(item => item.check == false)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择需要删除的图片',
          type: 'warning'
        });
        return false
      }

      this.$confirm('确认删除选中的图片？', {
        type: 'warning'
      }).then(
          () => {

            this.delLoading = true
            let param = {}
            let arr = []
            for(let i = 0; i < this.imgArray.length; i++) {
              if(this.imgArray[i].check) {
                arr.push(this.imgArray[i].id)
              }
            }
            param['idArr'] = arr
            // param['id'] = this.id
            postFormData(this.from==1?updateUserImgDel:this.from==2?delCommodityImg:this.from==3?updateStockTakeCommodityImgDel:this.from==4?uploadVisitImgDel:this.from==6?delStandardImg:'', param).then((data) => {
              let {msg, code} = data
              if (code == 200) {
                this.$message({
                  showClose: true,
                  duration: 2000,
                  message: msg,
                  type: 'success'
                });
                let imgList = this.imgArray.filter(item => !item.check)
                this.$emit('confirm', imgList)
              }else {
                this.$message({
                  showClose: true,
                  duration: 2000,
                  message: msg,
                  type: 'warning'
                });
              }
              this.loading = false
            }).catch(()=>{
              this.loading = false
            })

          }
      ).catch(() => {})
    },

    setCover(id) {
      postFormData(uploadCommodityImgCover,{id: id}).then(data => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },


  },
  mounted() {
    this.imgArray.map(item => {
      item.check = false
    })
  }
}
</script>

<style scoped>
.space-item{
  display: flex;
  font-size: 12px;
  line-height: 1.5;
  border: 0.02em solid #ebeef5;
}
.item-img {
  width: 190px;
  height: 190px;
}
.list-item {
  position: relative;
  cursor: pointer;
  width: 190px;
  height: 190px;
}
.list-item:hover > .scale-icon {
  display: flex;
}
.list-item:hover > .set-icon {
  display: flex;
}
.check-icon {
  position: absolute;
  width: 40px;
  height: 40px;
  top: 80px;
  left: 80px;
  background-color: #409eff;
  border-radius: 50%;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.scale-icon {
  position: absolute;
  right: 16px;
  bottom: 16px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: rgba(0,0,0,0.3);
  color: #ffffff;
  /*display: flex;*/
  align-items: center;
  justify-content: center;
  display: none;
}
.scale-icon:hover {
  background-color: rgba(0,0,0,0.8);
}
.set-icon {
  position: absolute;
  left: 16px;
  bottom: 16px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: rgba(0,0,0,0.3);
  color: #ffffff;
  /*display: flex;*/
  align-items: center;
  justify-content: center;
  display: none;
}
.set-icon:hover {
  background-color: rgba(0,0,0,0.8);
}
.cover-tag {
  position: absolute;
  top: 0;
  left: 0;
  padding: 2px 8px;
  font-size: 12px;
  color: #ffffff;
  background-color: #409eff;
  border-bottom-right-radius: 8px;
}
</style>
